import type { TranslationResources } from './en'

export const ar: TranslationResources = {
  app: {
    name: 'LogarGo',
    adminConsole: 'وحدة تحكم المشرف',
  },
  nav: {
    dashboard: 'لوحة التحكم',
    shipments: 'الشحنات',
    statistics: 'الإحصائيات',
    shipmentRequests: 'طلبات الشحن',
    jobs: 'المهام',
    jobOffers: 'عروض العمل',
    smsOptOuts: 'إلغاء اشتراك SMS',
    mitigationLadder: 'سلم - شبكة الأمان',
    accounts: 'الحسابات',
    allAccounts: 'جميع الحسابات',
    shippers: 'المرسلون',
    freighters: 'الناقلون',
    drivers: 'السائقون',
    vehicles: 'المركبات',
    liveTracking: 'التتبع المباشر',
    verifications: 'التحققات',
    disputes: 'النزاعات',
    scores: 'التقييمات',
    finance: 'المالية',
    subscriptions: 'الاشتراكات',
    activeSubscriptions: 'الاشتراكات النشطة',
    plans: 'الخطط',
    entitlements: 'الإضافات',
    campaigns: 'الحملات',
    billingControl: 'التحكم بالفوترة',
    notifications: 'الإشعارات',
    cronJobs: 'المهام المجدولة',
    systemHealth: 'صحة النظام',
    systemConfiguration: 'إعدادات النظام',
    settings: 'الإعدادات',
  },
  topbar: {
    switchToDark: 'التبديل إلى الوضع الداكن',
    switchToLight: 'التبديل إلى الوضع الفاتح',
    notifications: 'الإشعارات',
    profileSettings: 'إعدادات الملف الشخصي',
    logout: 'تسجيل الخروج',
    administrator: 'مشرف',
    detach: 'فصل الصفحة',
    openNewTab: 'فتح في علامة تبويب جديدة',
    openNewWindow: 'فتح في نافذة جديدة',
  },
  settings: {
    title: 'الإعدادات',
    subtitle: 'إدارة ملفك الشخصي واللغة والمظهر.',
    profileSection: 'الملف الشخصي',
    name: 'الاسم',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    role: 'الدور',
    status: 'الحالة',
    accountId: 'معرّف الحساب',
    preferencesSection: 'التفضيلات',
    language: 'اللغة',
    languageHelp:
      'يحدّث locale الحساب على الخادم. ستُسجَّل الخروج وتُعاد تحميل تسميات enum عند تسجيل الدخول التالي.',
    languageChangeTitle: 'تغيير اللغة',
    languageChangeConfirm: 'التبديل إلى الواجهة وتسميات enum بـ {{language}}؟',
    languageChangeConfirmHint: 'سيتم تحديث locale الحساب على الخادم. ستُسجَّل الخروج، كما في تطبيقات الجوال.',
    languageChangeConfirmAction: 'تغيير وتسجيل الخروج',
    languageChangeFailed: 'فشل تحديث اللغة',
    appearance: 'المظهر',
    themeMode: 'السمة',
    lightMode: 'فاتح',
    darkMode: 'داكن',
    languageChanged: 'تم تحديث اللغة',
    themeChanged: 'تم تحديث المظهر',
    notProvided: 'غير متوفر',
  },
  login: {
    subtitle: 'وحدة تحكم المشرف',
    emailLabel: 'البريد الإلكتروني',
    emailPlaceholder: 'admin@example.com',
    passwordLabel: 'كلمة المرور',
    signIn: 'تسجيل الدخول',
    signingIn: 'جارٍ تسجيل الدخول...',
    requiresAdmin: 'يتطلب صلاحيات SYSTEM_ADMIN',
    accessDenied: 'تم رفض الوصول. مطلوب دور SYSTEM_ADMIN.',
    loginFailed: 'فشل تسجيل الدخول. حاول مرة أخرى.',
    copyright: '© {{year}} LogarGo. منصة مطابقة المرسلين والناقلين.',
  },
  languages: {
    EN: 'الإنجليزية',
    HE: 'العبرية',
    AR: 'العربية',
    RU: 'الروسية',
  },
}
